/**
 * New Relic Browser Agent Configuration
 *
 * This file initializes the New Relic browser agent for monitoring.
 * It must be imported as early as possible in the application (first import in main.tsx).
 *
 * Using the NPM package instead of inline script for CSP compliance.
 * @see https://github.com/newrelic/newrelic-browser-agent
 */
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'

// Only initialize in non-development environments
// Development builds don't need browser monitoring
const isDevelopment = import.meta.env.DEV

if (!isDevelopment) {
  const options = {
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ['bam.nr-data.net'] }
    },
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: 'NRJS-daedc901bb6109df011',
      applicationID: '1103434441',
      sa: 1
    },
    loader_config: {
      accountID: '3290050',
      trustKey: '3290050',
      agentID: '1103434441',
      licenseKey: 'NRJS-daedc901bb6109df011',
      applicationID: '1103434441'
    }
  }

  new BrowserAgent(options)
}
